import React from 'react';

function DefaultCardIcon({ w, h, className, fill }) {
  return (
    <svg width={w} height={h} className={className} viewBox="0 0 34 24">
      <g fill="none" fillRule="evenodd">
        <rect width="33" height="23" x=".5" y=".5" fill="#FFF" stroke={fill} rx="3" />
        <path fill={fill} d="M1 6h32v6H1z" />
      </g>
    </svg>
  );
}

DefaultCardIcon.defaultProps = {
  w: 34,
  h: 24,
  fill: '#E1E1E1',
};

export default DefaultCardIcon;
